import React, { useState, useRef } from 'react'
import contact1 from './contact1.png'
import './Contact.css'
import emailjs from '@emailjs/browser'
import Swal from 'sweetalert2/dist/sweetalert2.js'

// import 'sweetalert2/src/sweetalert2.scss'

const Contact = () => {
  const [data, setData] = useState({
    username: '',
    // phone: '',
    email: '',
    subject: '',
    message: '',
  })

  const form = useRef()

  const InputEvent = (event) => {
    const { name, value } = event.target

    setData((preVal) => {
      return {
        ...preVal,
        [name]: value,
      }
    })
  }

  const formSubmit = (event) => {
    event.preventDefault()

    emailjs
      .sendForm('nascv', 'template_zn1e5bm', form.current, 'fITfgvWF5GbfNb5k2')
      .then(
        (result) => {
          console.log(result.text)
        },
        (error) => {
          console.log(error.text)
        }
      )
    Swal.fire({
      position: 'center',
      icon: 'success',
      title: 'Your Email sent',
      showConfirmButton: false,
      timer: 1500,
    })
  }
  return (
    <>
      <section className='Contact' id='contact'>
        <div className='container top'>
          <div className='heading text-center'>
            <h4>CONTACT</h4>
            <h1>Contact With Me</h1>
          </div>

          <div className='content d_flex'>
            <div className='left'>
              <div className='box box_shodow'>
                <div className='img'>
                  <img src={contact1} alt='' />
                </div>
                <div className='details'>
                  <h1>Nasution</h1>
                  <p>Fullstack Developer</p>
                  <p>
                    I am available for freelance work. Connect with me via and
                    call in to my account.
                  </p>{' '}
                  <br />
                  <p>
                    whatsapp:{' '}
                    <a href='https://wa.me/+6285237600085'>+6285237600085</a>
                  </p>
                  <p>Email: nasutioncode@gmail.com</p> <br />
                  <span>FIND WITH ME</span>
                  <div
                    className='button f_flex'
                    style={{ marginBottom: '20px' }}
                  >
                    <div className='button'>
                      <a
                        href='https://github.com/nascript/'
                        target='_blank'
                        className='btn_shadow'
                        rel='noreferrer'
                        style={{ marginLeft: '12px' }}
                      >
                        <i class='fab fa-github'></i>
                      </a>
                      <a
                        href='https://www.linkedin.com/in/nasutioncode/'
                        target='_blank'
                        className='btn_shadow'
                        rel='noreferrer'
                        style={{ marginLeft: '12px' }}
                      >
                        <i class='fab fa-linkedin-in'></i>
                      </a>
                      <a
                        href='https://www.instagram.com/nascodefy/'
                        target='_blank'
                        className='btn_shadow'
                        rel='noreferrer'
                        style={{ marginLeft: '12px' }}
                      >
                        <i class='fab fa-instagram'></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='right box_shodow'>
              <form ref={form} onSubmit={formSubmit}>
                {/* <div className='f_flex'>
                  <div className='input row'>
                    <span>YOUR NAME</span>
                    <input
                      type='text'
                      name='username'
                      value={data.username}
                      onChange={InputEvent}
                    />
                  </div>
                  <div className='input row'>
                    <span>PHONE NUMBER </span>
                    <input
                      type='number'
                      name='phone'
                      value={data.phone}
                      onChange={InputEvent}
                    />
                  </div>
                </div> */}
                <div className='input'>
                  <span>YOUR NAME</span>
                  <input
                    type='text'
                    name='username'
                    value={data.username}
                    onChange={InputEvent}
                    required
                  />
                </div>
                <div className='input'>
                  <span>EMAIL </span>
                  <input
                    type='email'
                    name='email'
                    value={data.email}
                    onChange={InputEvent}
                    required
                  />
                </div>
                <div className='input'>
                  <span>SUBJECT </span>
                  <input
                    type='text'
                    name='subject'
                    value={data.subject}
                    onChange={InputEvent}
                    required
                  />
                </div>
                <div className='input'>
                  <span>YOUR MESSAGE </span>
                  <textarea
                    cols='30'
                    rows='10'
                    name='message'
                    value={data.message}
                    onChange={InputEvent}
                    required
                  ></textarea>
                </div>
                <button className='btn_shadow'>
                  SEND MESSAGE <i className='fa fa-long-arrow-right'></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Contact
